module.exports = __webpack_public_path__ + "images/3f05d16744365264ef9e63330f4cf51f.png";